import TagElement from '../TagElement';

export default function Tag(params) {
    const { data, innerMethods } = params;

    const tagCell = document.createElement('div');
    tagCell.classList.add('w5-tag-cell');
    const tagInfo = innerMethods?.getInfoForTag?.(data) || null;

    if (!tagInfo?.value) return tagCell;
    const tagElement = TagElement(tagInfo);

    if (!tagElement) return tagCell;
    if (tagInfo?.extraTags) {
        tagCell.classList.add('w5-multi-tag-cell');
        tagCell.appendChild(tagElement);
        tagInfo?.extraTags?.forEach((tag) => tagCell.appendChild(TagElement(tag)));
    } else {
        tagCell.appendChild(tagElement);
    }

    return tagCell;
}
